import { render, staticRenderFns } from "./SliderList.vue?vue&type=template&id=6c57075c"
import script from "./SliderList.vue?vue&type=script&lang=ts"
export * from "./SliderList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports